 <template>
  <el-row class="el-row_h">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow: auto;">
        <el-input style="min-width: 150px;" placeholder="请输入用户关键字搜索" v-model="keyWord" clearable size="small" class="s_padding filterSelect">
        </el-input>
        <el-input style="min-width: 150px" placeholder="请输入合约关键字搜索" v-model="ContractKeyVal" clearable size="small" class="s_padding filterSelect">
        </el-input>
        <dateRangeHis ref="dateRange"></dateRangeHis>
        <el-select v-model="PositionEffectValue" size="small" placeholder="请选择" class="s_padding" style="width:80px;min-width: 80px;">
          <el-option v-for="item in PositionEffectList" :key="item.Code" :label="item.Name" :value="item.Code">
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getList()">查询</el-button>
      </div>
      <div style="height: 100%;">
        <tableCom :data="delegateList" v-loading="loading"></tableCom>
      </div>
      <div class="pagination_m2 text-center">
        <pagination :pagerPro="Pager" @ee="pageFn"></pagination>
      </div>
      <!-- <div class="footer grid-content bg-purple layout_box">
        <span class="text-right">
          佣金合计:
          <span class="capital">{{totalCapital}}</span>
          <span class="Currency"> (美元)</span>
          &nbsp;&nbsp;&nbsp; 平仓盈亏:
          <span class="capital">{{totalCurrency}}</span>
          <span class="Currency"> (美元)</span>
        </span>
      </div> -->
    </el-col>
  </el-row>
</template>
<script>
import tableCom from "./delegationDetailT.vue";
import pagination from "../../paging.vue";
import dateRangeHis from "../../dateRangeSubHis.vue";
import SeachConPage from "../SeachConPage.vue";

export default {
  // 筛选器
  name: "dealDetailS",
  props: ["agentID"],
  components: {
    tableCom,
    pagination,
    dateRangeHis,
    SeachConPage
  },
  data() {
    return {
      loading: "",
      Pager: {
        PageNo: 1,
        PageSize: 10,
        RecordCount: 0
      },
      delegateList: [],
      totalCapital: 0,
      totalCurrency: 0,
      PositionEffectValue: 1,
      PositionEffectList: [
        { Code: 1, Name: "开仓" },
        { Code: 2, Name: "平仓" }
      ],
      keyWord: "",
      ContractKeyVal: "",
      queryobj:{}
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(isSearch = true) {
      if (isSearch) {
        this.Pager = {
          PageNo: 1,
          PageSize: 20,
          RecordCount: 0
        };
      }
      this.queryobj={
        UserKey:this.keyWord,
        ContractKey: this.ContractKeyVal,
        PositionEffect: this.PositionEffectValue,
        BeginDate: this.$refs.dateRange.DateRangeValue[0],
        EndDate: this.$refs.dateRange.DateRangeValue[1]
      }
      this.$emit("delegation", this.queryobj);
      this.loading = true;
      let url = "/report/QryAgentUserHistoryOrder";
      let postData = {
        AgentIds: this.agentID,
        UserKey: this.keyWord,
        ContractKey: this.ContractKeyVal,
        PositionEffect: this.PositionEffectValue,
        BeginDate: this.$refs.dateRange.DateRangeValue[0],
        EndDate: this.$refs.dateRange.DateRangeValue[1]
      };

      this.$loginapi.postWithPage(
        url,
        this.Pager.PageNo,
        this.Pager.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.delegateList = response.Data.Records;
            this.totalCapital = 0;
            this.totalCurrency = 0;

            if (this.Pager.PageNo == 1) {
              this.Pager = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getList(false);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selects/delegation/delegationDetailS.vue